function initSlider(sectionSelector, listSelector, prevSelector, nextSelector, dotsSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const list = section.querySelector(listSelector);
  const prevBtn = section.querySelector(prevSelector);
  const nextBtn = section.querySelector(nextSelector);
  const dotsContainer = section.querySelector(dotsSelector);

  if (!list) return;

  const items = list.children;
  const totalSlides = items.length;

  let current = 0;

  // створюємо dots
  if (dotsContainer) {
    dotsContainer.innerHTML = '';

    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('span');
      dot.classList.add('slider-dot');

      if (i === 0) dot.classList.add('active');

      dot.addEventListener('click', () => {
        current = i;
        scrollToSlide();
      });

      dotsContainer.appendChild(dot);
    }
  }

  function updateDots() {
    if (!dotsContainer) return;

    const dots = dotsContainer.querySelectorAll('.slider-dot');

    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === current);
    });
  }

  function scrollToSlide() {
    const step = list.clientWidth;

    list.scrollTo({
      left: step * current,
      behavior: 'smooth'
    });

    updateDots();
  }

  const scroll = (direction) => {
    const max = totalSlides - 1;

    if (direction === 'next') current = Math.min(current + 1, max);
    else current = Math.max(current - 1, 0);

    scrollToSlide();
  };

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (getComputedStyle(nextBtn).display !== 'none') scroll('next');
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (getComputedStyle(prevBtn).display !== 'none') scroll('prev');
    });
  }
}

initSlider(
  '.about-section',
  '.about-cards',
  '.btn-prev',
  '.btn-next',
  '.slider-dots'
);

initSlider(
  '.progression-section',
  '.progression-cards',
  '.btn-prev',
  '.btn-next',
  '.slider-dots'
);